(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const heroElements = document.querySelectorAll('[data-slideshow]');

    heroElements.forEach(function(hero) {
      const track = hero.querySelector('[data-slideshow-track]');
      if (!track) return;

      const slides = track.querySelectorAll('.hero__slide');
      const slideCount = parseInt(hero.dataset.slideCount, 10);
      if (slideCount <= 1) return;

      const autoplay = hero.dataset.autoplay === 'true';
      const autoplaySpeed = (parseInt(hero.dataset.autoplaySpeed, 10) || 5) * 1000;
      const prevBtn = hero.querySelector('[data-slide-prev]');
      const nextBtn = hero.querySelector('[data-slide-next]');
      const dots = hero.querySelectorAll('[data-slide-dot]');

      let currentIndex = 0;
      let autoplayTimer = null;
      let isTransitioning = false;
      let touchStartX = 0;
      let touchEndX = 0;

      function goToSlide(index, direction) {
        if (isTransitioning || index === currentIndex) return;
        isTransitioning = true;

        /* Eski slide'ı deaktif et */
        slides[currentIndex].classList.remove('hero__slide--active');

        /* Yeni slide'ı aktif et */
        currentIndex = index;
        slides[currentIndex].classList.add('hero__slide--active');

        /* Dot güncelle */
        dots.forEach(function(dot, i) {
          dot.classList.remove('hero__dot--active');
          var progress = dot.querySelector('[data-dot-progress]');
          if (progress) {
            progress.classList.remove('hero__dot-progress--animating');
            progress.remove();
          }

          if (i < currentIndex) {
            dot.classList.add('hero__dot--visited');
          } else {
            dot.classList.remove('hero__dot--visited');
          }
        });

        if (dots[currentIndex]) {
          dots[currentIndex].classList.add('hero__dot--active');

          if (autoplay) {
            var inner = dots[currentIndex].querySelector('.hero__dot-inner');
            var progressEl = document.createElement('span');
            progressEl.classList.add('hero__dot-progress');
            progressEl.setAttribute('data-dot-progress', '');
            inner.appendChild(progressEl);

            /* Force reflow */
            progressEl.offsetWidth;
            progressEl.classList.add('hero__dot-progress--animating');
          }
        }

        /* Video yönetimi */
        slides.forEach(function(slide, i) {
          var videos = slide.querySelectorAll('video');
          videos.forEach(function(video) {
            if (i === currentIndex) {
              video.play().catch(function() {});
            } else {
              video.pause();
              video.currentTime = 0;
            }
          });
        });

        setTimeout(function() {
          isTransitioning = false;
        }, 600);

        resetAutoplay();
      }

      function nextSlide() {
        var next = (currentIndex + 1) % slideCount;
        goToSlide(next, 'next');
      }

      function prevSlide() {
        var prev = (currentIndex - 1 + slideCount) % slideCount;
        goToSlide(prev, 'prev');
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function resetAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        startAutoplay();
      }

      /* Arrow click */
      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      if (nextBtn) nextBtn.addEventListener('click', nextSlide);

      /* Dot click */
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(dot.dataset.slideDot, 10);
          goToSlide(index, index > currentIndex ? 'next' : 'prev');
        });
      });

      /* Touch/Swipe */
      track.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      track.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      }, { passive: true });

      /* Hover'da autoplay durdur */
      hero.addEventListener('mouseenter', stopAutoplay);
      hero.addEventListener('mouseleave', startAutoplay);

      /* Klavye navigasyonu */
      hero.setAttribute('tabindex', '0');
      hero.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      });

      /* İlk slide için progress bar başlat */
      if (autoplay && dots[0]) {
        var firstProgress = dots[0].querySelector('[data-dot-progress]');
        if (firstProgress) {
          firstProgress.offsetWidth;
          firstProgress.classList.add('hero__dot-progress--animating');
        }
      }

      /* Autoplay başlat */
      startAutoplay();

      /* Visibility API - tab değişince durdur */
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
